import { getTabContainer } from '../../apia/main/TabsList/ContentRenderer';

export default function closeTab() {
  getTabContainer().removeActiveTab();
}
